module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.discountTypes) ? _c('div', {
    staticClass: "discount"
  }, [(_vm.showDiscount) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-auto align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.billing.discountValue),
      expression: "form.billing.discountValue"
    }],
    ref: "discountInput",
    staticClass: "glued-right",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.billing.discountValue)
    },
    on: {
      "keyup": _vm.validateDiscount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.billing, "discountValue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('vSelect', {
    staticClass: "glued-left",
    attrs: {
      "options": _vm.discountTypes,
      "searchable": false,
      "label": "symbol"
    },
    on: {
      "input": _vm.updateDiscountType
    },
    model: {
      value: (_vm.selectedDiscountType),
      callback: function($$v) {
        _vm.selectedDiscountType = $$v
      },
      expression: "selectedDiscountType"
    }
  })], 1)]) : _c('div', {
    staticClass: "bold"
  }, [_c('div', {
    on: {
      "click": _vm.openDiscount
    }
  }, [_c('i', {
    staticClass: "ico-add color-1 add-circle border-color-1"
  }), _vm._v("\n            Add discount\n        ")])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-02ae2980", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ae2980"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Discount.vue
// module id = 1220
// module chunks = 0